module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('fieldset', [_c('legend', [_vm._v("Seções")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-success",
    attrs: {
      "id": "btn-add-field",
      "to": {
        name: 'FormSectionDetail',
        params: {
          reqType: _vm.reqType,
          id: null
        }
      },
      "type": "button"
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-plus"
  }), _vm._v(" Adicionar Seção\n  ")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), (_vm.updating) ? _c('loader') : _vm._e(), _vm._v(" "), (_vm.sections.length == 0) ? _c('div', {
    staticClass: "alert alert-info",
    attrs: {
      "id": "msg-no-sections"
    }
  }, [_vm._v("\n            Formulário ainda não possui seções\n    ")]) : _c('draggable', {
    staticClass: "list-group",
    on: {
      "end": _vm.checkMove
    },
    model: {
      value: (_vm.sections),
      callback: function($$v) {
        _vm.sections = $$v
      },
      expression: "sections"
    }
  }, _vm._l((_vm.sections), function(s) {
    return _c('div', {
      staticClass: "list-group-item"
    }, [_c('h4', {
      staticClass: "list-group-item-heading"
    }, [_vm._v("\n            " + _vm._s(s.name) + "\n            "), _c('span', {
      staticClass: "pull-right"
    }, [_c('span', {
      staticClass: "badge"
    }, [_vm._v(_vm._s(_vm.counts[s.objectId]) + " campo(s)")]), _vm._v(" "), _c('router-link', {
      staticClass: "btn btn-xs btn-primary",
      attrs: {
        "to": {
          name: 'FormSectionDetail',
          params: {
            reqType: _vm.reqType,
            id: s.objectId
          }
        },
        "type": "button",
        "title": "Editar Seção"
      }
    }, [_c('span', {
      staticClass: "glyphicon glyphicon-edit"
    }), _vm._v(" Editar\n              ")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-xs btn-danger",
      attrs: {
        "title": "Remover Seção"
      },
      on: {
        "click": function($event) {
          return _vm.remove(s)
        }
      }
    }, [_c('span', {
      staticClass: "glyphicon glyphicon-remove"
    }), _vm._v(" Remover\n              ")])], 1)]), _vm._v(" "), _c('p', {
      staticClass: "list-group-item-text"
    }, [_vm._v(_vm._s(s.description))])])
  }), 0)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5e808fba"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FormSectionList.vue
// module id = 1455
// module chunks = 1